import React, { Suspense, useCallback, useEffect, useMemo,useRef, useState } from 'react';
import {
  NavigationContainer,
  useNavigationContainerRef,
  createNavigationContainerRef
} from '@react-navigation/native';
import { Linking, Platform  , StatusBar, Text, View } from 'react-native';
import { SafeAreaView } from 'react-native-safe-area-context';
import AppRoutes from './navigationApp';
import InterceptorSetup from './api/interceptor';
import { I18nextProvider } from 'react-i18next';
import { i18n } from './lang/i18n';
import { ThemeProvider } from '@shopify/restyle';
import { createDynamicTheme } from './theme';
import { useAppSelector } from './store/hooks'
import AsyncStorage from '@react-native-async-storage/async-storage';
import LogOutUser from './helper/logout';
import { getParameters, isIframeCheck, trackEvent, useDarkMode } from './utils';
import useDeepLinking from './utils/deepLinking/deepLinking';
import PageLoader from './sharedComponents/PageLoader/PageLoader';
import ForceUpdateModal from './sharedComponents/ForceUpdateModal';
import useForceUpdate from './hooks/useForceUpdateModal';
const isReadyRef = { current: false };
const routesMap = {
  FLEXI_PAY:"principal",
  INTEREST_PAYMENT:"interest",
  SHORTFALL_REPAY:"shortfall",
}

InterceptorSetup();
const NewApp = () => {
  const navigationRef = useNavigationContainerRef();
  const routeNameRef = useRef();

  const isDarkMode = useDarkMode();
  let primaryColor = null;
  let platform = null;
  if(Platform.OS === 'web'){
    primaryColor = getParameters(window?.location?.href).primaryColor;
    platform = getParameters(window?.location?.href).platform;
  }

  const theme = useMemo(
    () => createDynamicTheme('core', isDarkMode ? 'dark' : 'light',primaryColor, undefined, platform),
    [],
  );

  useEffect(() => {
    isReadyRef.current = true;
    return () => {
        isReadyRef.current = false;
    };
  }, []);

  const handleDeepLink = useCallback((params: Record<string, any>) => {
    if (
      params &&
      isReadyRef.current &&
      params.screen
    ) {
      // @ts-expect-error
      navigationRef.navigate(params.screen, params);
    }
  }, [isReadyRef.current, navigationRef]);

  useDeepLinking(handleDeepLink);

  return (
    <ThemeProvider theme={theme}>
      <View style={{ flex: 1 }}>
        <NavigationContainer
          documentTitle={{
            enabled: true,
            formatter: () => {
              return `Volt - Unlock cash from your mutual funds saving`
            },
          }}
          ref={navigationRef}
          onReady={()=>(isReadyRef.current = true)}
          onStateChange={async () => {
            const previousRouteName = routeNameRef?.current;
            const currentRouteName = navigationRef?.getCurrentRoute()?.name;
            if (previousRouteName !== currentRouteName) {
              // Save the current route name for later comparison
              routeNameRef.current = currentRouteName;
              
              // Replace the line below to add the tracker from a mobile analytics SDK
              trackEvent(`${currentRouteName}_PAGE_VIEWED`,{source:routesMap[previousRouteName]??previousRouteName});
            }
            console.log('current new arch route', navigationRef?.getCurrentRoute()?.name)
          }}
          onUnhandledAction={async (action: any) => {
            console.log(
              'Unhandled action',
              action.payload.name,
              action.payload.params,
            );
            let accessToken = null
            if(Platform.OS === 'web'){
              const isAccessTokenInCookiPreset = document.cookie.split(';').some((item) => item.trim().startsWith('access_token='));
              if(isAccessTokenInCookiPreset){
                const accessTokenCookie = document.cookie.split(';').find((item) => item.trim().startsWith('access_token='));
                accessToken = accessTokenCookie?.split('=')[1];
              }
              if(!isAccessTokenInCookiPreset && isIframeCheck()){
                accessToken = await AsyncStorage.getItem('access_token');
                if(Boolean(accessToken)){
               }
              }
            }else{
             accessToken = await AsyncStorage.getItem('access_token');
            }
            if(accessToken){
          }
          else{
            LogOutUser()
          }
          }}
        >
          <I18nextProvider i18n={i18n}>
            <Suspense fallback={<PageLoader />}>
              <AppRoutes />
            </Suspense>
          </I18nextProvider>
        </NavigationContainer>
      </View>
    </ThemeProvider>
  );
};
export default NewApp;
